import { MDBIcon, MDBRow } from "mdbreact";
import React from "react";
import TenantSelectElement from "../../elements/tenant-select-element/TenantSelectElement";
import classes from "./TenantSelectSlider.module.scss";
import { Recommend } from "../../../containers/StampCard";

type TenantSelectSliderProps = {
  /** ヘッダアイコン */
  headerIcon: string;
  /** ヘッダテキスト */
  headerText: string;
  /** テナントのリスト */
  tenants: {
    /** テナントスタンプID */
    id: string;
    /** テナント名 */
    name: string;
    /** テナント画像URL */
    image: string;
    /** テナント選択状態 */
    isChecked?: boolean;
  }[];
  /** 既に1テナント選択済みかどうか*/
  isSelected: boolean;
  /** スタンプのクリックイベント */
  onStampClick: (recommend: Recommend) => void;
  /** 「さらに表示」のクリックイベント */
  onMorePanelClick: () => void;
};

const TenantSelectSlider: React.FC<TenantSelectSliderProps> = (props) => {
  return (
    <div>
      <div className={`${classes.categoryHeader} d-table w-100 mt-3`}>
        <div className="d-table-cell text-left">
          <MDBIcon icon={props.headerIcon} />
          <span className="ml-2">{props.headerText}</span>
        </div>
        <div className="d-table-cell text-right">
          {props.isSelected ? (
            <span className={`${classes.selectedBadge}`}>
              <MDBIcon icon="check" />
              <span className="ml-1">選択済</span>
            </span>
          ) : null}
        </div>
      </div>
      {props.tenants.length !== 0 && !props.isSelected ? (
        <MDBRow className="mt-2 mx-1">
          <ul className={`py-3 px-2 my-0 ${classes.sliderCarousel}`}>
            {props.tenants.map((tenant) => {
              return (
                <li className={`mx-1 ${classes.carouselItem}`} key={tenant.id}>
                  <TenantSelectElement
                    id={tenant.id}
                    name={tenant.name}
                    image={tenant.image}
                    isChecked={tenant.isChecked}
                    onClick={props.onStampClick}
                  ></TenantSelectElement>
                </li>
              );
            })}
            <li className={`mx-1 ${classes.carouselItem}`}>
              <div className={classes.morePanel}>
                <div className={classes.label} onClick={props.onMorePanelClick}>
                  <MDBIcon icon="chevron-circle-right" className="mr-1" />
                  さらに表示
                </div>
              </div>
            </li>
          </ul>
        </MDBRow>
      ) : null}
    </div>
  );
};

export default TenantSelectSlider;
